import { render, staticRenderFns } from "./TheToolsBar.vue?vue&type=template&id=87bc14c4&scoped=true&"
import script from "./TheToolsBar.vue?vue&type=script&lang=js&"
export * from "./TheToolsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bc14c4",
  null
  
)

export default component.exports